<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :initial-data="initialData" :save-params="{api_key: currentUser.api_key}">

        <div class="col-12">
            <validated-input name="Title" label="Title" v-model="model.title"
                             :rules="{required:true}" :disabled="loading"/>
        </div>
        <div class="col-12">
            <file-input class="c-file-input" label="Thumbnail" v-model="model.thumbnail" :disabled="loading">
                <template #append v-if="model.thumbnail">
                    <btn class="ml-auto" type="button" size="xs"
                         title="View Image" @click="viewFile(model.thumbnail)"/>
                </template>
            </file-input>
        </div>
        <div class="col-12">
            <image-info :width="690" :height="500"/>
        </div>
        <div class="col-12">
            <validated-input name="Video Link" label="Video Link" v-model="model.video_link"
                             :rules="{required:true}" :disabled="loading"/>
        </div>
        <div class="col-12">
            <checkbox-input class="col-6" label="Disable" v-model="model.disabled"
                            :rules="{required:false}" :disabled="loading"/>
        </div>
        <div class="col-12 mt-2">
            <btn class="trn" size="sm" :loading="loading" color="primary" text="Update"
                 loading-text="Updating..." :disabled="loading"/>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'EditVideo',
    props    : { initialData : { type : Object } },
    computed : { ...mapGetters(['currentUser']) },
    data () {
        return {
            addUrl : urls.admin.event.videoGallery.addEdit
        };
    },
    methods : {
        viewFile (url) {
            window.open(url);
        },
        formSuccess () {
            this.$notify('Successfully Edited Video..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;
            if (json.permission === false) {
                this.$notify('Invalid Authentication..!', 'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
            }
        }
    }
};
</script>

<style scoped>

</style>
